
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        title: {
            type: String,
            default: null
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['close'],
    setup(props, { emit }) {
        const onClose = () => {
            if (props.loading) return
            emit('close')
        }

        return {
            onClose
        }
    }
})
